import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col } from 'react-bootstrap';
import PosicionDataService from './services/posicion.service.js';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";

function UpdatePosicion(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);


  const [nombreposicion, setnombreposicion] = useState("");
  const [descripcionposicion, setdescripcionposicion] = useState("");    
  
  const { user } = useSelector(state => state.auth);

  const onChangenombreposicion = (e) => {  
    //console.log(e.target.value);
    const nombreposicion = e.target.value;
    setnombreposicion(nombreposicion);
  };

  const onChangedescripcionposicion = (e) => {  
    //console.log(e.target.value);
    const descripcionposicion = e.target.value;
    setdescripcionposicion(descripcionposicion);
  };
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    PosicionDataService.get(props.id)
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setnombreposicion(response.data.nombreposicion);
        setdescripcionposicion(response.data.descripcionposicion);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    savePosicion();
  } 

  let savePosicion = (e)  =>{ 
    console.log(e);
    console.log(nombreposicion);
    console.log(descripcionposicion);
    console.log(e.nombreposicion);
    console.log(e.descripcionposicion);   

    if (nombreposicion.length == 0) {
      setErrmessage("El nombre de la posición no puede ser vacío.");
      setShowerror(true);
    }  
    else {
      var data = {
        nombreposicion: e.nombreposicion,
        descripcionposicion: e.descripcionposicion,
      }
      
      console.log(data);
      
      PosicionDataService.update(props.id, data)
      .then(response => {
        console.log(response);
        setSubmitted(true);
        setSuccmessage('Se actualizó la posición.');
        setShowsuccess(true);
        setErrmessage('');
        setShowerror(false);        
        handleClose();
      })
      .catch(e => {
        console.log(e);
        setErrmessage(e.response?e.response.data.message:e.message);
        setShowerror(true);      
        setSuccmessage('');
        setShowsuccess(false);            
      })   
  
    }    
  }


    return (
      <>
        <Button variant="secondary" onClick={handleShow}><FaEdit size={15}/></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Actualizar área'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(savePosicion)}>
              <Row className='mt-2'>
                <Col className='col-md-3' sm={8}>
                    <Controller
                      name="nombreposicion"
                      control={control}
                      onChange={onChangenombreposicion}
                      defaultValue={nombreposicion}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                            className="m-2"
                            type="text"
                            placeholder="Nombre posición"
                            isInvalid={errors.nombreposicion}
                            
                        />
                      )}
                    />
                    {errors.nombreposicion && (
                      <Form.Control.Feedback type="invalid">
                        Se requiere el nombre de la posición.
                      </Form.Control.Feedback>
                    )}
                </Col>
                <Col className='col-md-6' md={3}>
                  <Controller
                    name="descripcionposicion"
                    control={control}
                    onChange={onChangedescripcionposicion}
                    defaultValue={descripcionposicion}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Descripción posición"
                          isInvalid={errors.descripcionposicion}
                          
                      />
                    )}
                  />
                  {errors.descripcionposicion && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere la descripción de la posición.
                    </Form.Control.Feedback>
                  )}        
                </Col>
              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default UpdatePosicion;